import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=489bce79&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=489bce79&lang=scss&scoped=true"
import style1 from "./BarChart.vue?vue&type=style&index=1&id=489bce79&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bce79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489bce79')) {
      api.createRecord('489bce79', component.options)
    } else {
      api.reload('489bce79', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=489bce79&scoped=true", function () {
      api.rerender('489bce79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/panels/BarChart.vue"
export default component.exports